import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const ArticleContent = styled.div`
  position: relative;
  width: 100%;
  max-width: ${rem(1240)};
  margin: auto;
  ${media.tabletMedium} {
    padding: ${rem(24)} 0 ${rem(64)};
  }
  padding-top: 0;
  padding-bottom: ${rem(52)};
`;

export default ArticleContent;
